import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../../pages/Teacher/Home";
import HelpSupport from "../../pages/Teacher/HelpSupport";
import SurveysComingSoon from "../SurveysComingSoon";
import StandardsProgression from "../../pages/Teacher/StandardsProgression";
import StandardProgressionsReference from "../../pages/Teacher/StandardProgressionsReference";
import StudentProfiles from "../../pages/Teacher/StudentProfiles";
import StudentDetail from "../../pages/Teacher/StudentDetail";
import SubjectInfo from "../../pages/Teacher/SubjectInfo";
import StandardGradeEntry from "../../pages/Teacher/StandardGradeEntry";
import ClassGroupsPage from "../../pages/Teacher/ClassGroupsPage";
import { useAuth } from "../../context/AuthContext";
import { isReadOnlyTeacherDemo } from "../../utils/demoAccess";
import BulkReportDownload from "../../pages/Teacher/BulkReportDownload";
import ConnectChat from "../../pages/Teacher/ConnectChat";
import StudentProgressPage from "../../pages/StudentProgressPage";
import TeacherParentPreview from "../../pages/Teacher/TeacherParentPreview";
import DataPointsReport from "../../pages/DataPointsReport";
import ReportsPage from "../../pages/ReportsPage";
import AtHomeSupportPage from "../../pages/AtHomeSupportPage";
import TeacherRequests from "../../pages/Teacher/Requests";
import FamilyActionCards from "../../pages/Teacher/FamilyActionCards";
import TeacherGuidedActions from "../../pages/Teacher/TeacherGuidedActions";
import TrainingResourcesPage from "../../pages/TrainingResourcesPage";
import ClassManagePage from '../../pages/Teacher/ClassManagePage';
import AssignmentsPage from '../../pages/Teacher/AssignmentsPage';
import CommunicationHub from '../../pages/Teacher/CommunicationHub';
import TeacherCalendar from '../../pages/Teacher/TeacherCalendar';
import TeacherNotes from '../../pages/Teacher/TeacherNotes';
const TeacherDashboard = () => {
  const { user } = useAuth();
  if (isReadOnlyTeacherDemo(user)) {
    return (
      <Routes>
        <Route path="home" element={<Home />} />
        <Route path="student-profiles" element={<StudentProfiles />} />
        <Route path="student-profiles/:classId/:subject" element={<StudentProfiles />} />
        <Route path="student/:studentId" element={<StudentDetail />} />
        <Route path="student-progress/:studentId" element={<StudentProgressPage role="teacher" />} />
        <Route path="student-progress/:studentId/:classId" element={<StudentProgressPage role="teacher" />} />
        <Route path="standards-progression" element={<StandardsProgression />} />
        <Route path="grade-entry" element={<StandardGradeEntry />} />
        <Route path="student-progress-family/:studentId" element={<TeacherParentPreview />} />
        <Route path="student-progress-family/:studentId/:classId" element={<TeacherParentPreview />} />
        <Route path="*" element={<Navigate to="/teacher/home" replace />} />
      </Routes>
    );
  }
  return (
  <Routes>
    <Route path="home" element={<Home />} />
    <Route path="grading" element={<Home />} />
    <Route path="classes" element={<Home />} />
    <Route path="help-support" element={<HelpSupport />} />
    <Route path="surveys" element={<SurveysComingSoon audience="teacher" />} />
    <Route path="standards-progression" element={<StandardsProgression />} />
    <Route path="standard-progressions" element={<StandardProgressionsReference />} />
    <Route path="grade-entry" element={<StandardGradeEntry />} />
    <Route path="assignments/*" element={<AssignmentsPage />} />
    <Route path="communication" element={<CommunicationHub />} />
    <Route path="calendar" element={<TeacherCalendar />} />
    <Route path="notes" element={<TeacherNotes />} />
    <Route path="data-points" element={<DataPointsReport role="teacher" />} />
    <Route path="action" element={<TeacherRequests />} />
    <Route path="action-cards" element={<FamilyActionCards />} />
    <Route path="guided-actions" element={<TeacherGuidedActions />} />
    <Route path="connect" element={<ConnectChat />} />
    <Route path="messaging" element={<ConnectChat />} />
    <Route path="professional-development" element={<Navigate to="/teacher/training-resources" replace />} />
    <Route path="training-resources" element={<TrainingResourcesPage role="teacher" />} />
    <Route path="class-manage/:classId" element={<ClassManagePage />} />
    <Route path="student-profiles" element={<StudentProfiles />} />
    <Route path="student-profiles/:classId/:subject" element={<StudentProfiles />} />
    <Route path="class-groups/:classId" element={<ClassGroupsPage />} />
    <Route path="bulk-reports/:classId" element={<BulkReportDownload />} />
    <Route path="student/:studentId" element={<StudentDetail />} />
    <Route path="subject-info" element={<SubjectInfo />} />
    <Route path="student-progress/:studentId" element={<StudentProgressPage role="teacher" />} />
    <Route path="student-progress/:studentId/:classId" element={<StudentProgressPage role="teacher" />} />
    <Route path="student-progress-family/:studentId" element={<TeacherParentPreview />} />
    <Route path="student-progress-family/:studentId/:classId" element={<TeacherParentPreview />} />
    <Route path="data-points-report" element={<DataPointsReport role="teacher" />} />
    <Route path="reports" element={<ReportsPage role="teacher" />} />
    <Route path="at-home-support" element={<AtHomeSupportPage />} />
    <Route path="requests" element={<TeacherRequests />} />
    <Route path="*" element={<Navigate to="/teacher/home" replace />} />
  </Routes>
  );
};

export default TeacherDashboard;
